<template>
  <div class="save-dialog">
    <PilotEnds
      v-if="isAmex"
      mainText="The AMEX Trips pilot will end on February 28th, 2023. To save the itinerary for this trip,"
      actionText="download itinerary as pdf"
      :action="onDownloadPdf"
      class="pilot-ends-alignment"
    />
    <button class="save-dialog__close" @click="onClose"><CrossIcon /></button>
    <header class="save-dialog__header">
      <img :src="image" alt="..." class="save-dialog__image" />
    </header>
    <div class="save-dialog__title">Save your Trip</div>
    <div class="save-dialog__description">
      Save the perfect itinerary and keep all of your bookings in one place.
    </div>
    <button class="download-btn" :class="{loading: isPDFLoading}" @click="onDownloadPdf">
      <SpinnerIcon class="icon" v-if="isPDFLoading" />
      <DownloadIcon class="icon" v-else />
      <span>Download itinerary as pdf here</span>
    </button>
    <!-- <div class="save-dialog__form">
      <label class="save-dialog__label" for="name"> Trip Name </label>
      <input id="name" type="text" v-model="name" class="save-dialog__input" />
      <button class="save-dialog__button" @click="save">Save</button>
    </div> -->
    <!---

    <div class="download-pdf-reminder">To ensure that you can view your trip itinerary, remember to</div>
    <button class="download-btn" :class="{loading: isPDFLoading}" @click="onDownloadPdf">
      <SpinnerIcon class="icon" v-if="isPDFLoading" />
      <DownloadIcon class="icon" v-else />
      <span>download itinerary as pdf here</span>
    </button>
    --->
  </div>
</template>

<script>
import CrossIcon from '../svg/cross.vue';
import SpinnerIcon from '../svg/spinner-icon.vue';
import DownloadIcon from '../svg/download-icon.vue';
import PilotEnds from '@common/pilot-ends.vue';

export default {
  components: {
    CrossIcon,
    SpinnerIcon,
    DownloadIcon,
    PilotEnds,
  },
  name: 'AmexSummarySaveDialog',
  props: {
    image: {
      type: String,
      required: true,
    },
    tripName: {
      type: String,
      default: '',
    },
    isPDFLoading: Boolean,
  },
  data() {
    return {
      name: this.tripName,
      isAmex: process.env.VUE_APP_THEME === 'AMEX',
    };
  },
  methods: {
    save() {
      this.$emit('save', this.name);
    },
    onClose() {
      this.$emit('close');
    },
    onDownloadPdf() {
      this.$emit('download');
    },
  },
};
</script>

<style lang="scss" scoped>
.pilot-ends-alignment {
  margin: -20px -20px 20px;
}
.download-btn {
  border: 0;
  appearance: none;
  cursor: pointer;
  background: none;
  color: var(--btn-primary-color, hsl(208, 100%, 41%));
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 118.14%;
  letter-spacing: -0.005em;
  position: relative;
  display: flex;
  align-items: center;

  > * + * {
    margin-left: 10px;
  }
}

.download-pdf-reminder {
  padding-top: 15px;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 118.14%;
  text-align: center;
  letter-spacing: -0.005em;
  color: rgba(7, 29, 59, 0.5);
  border-top: 1px solid #f1f1f1;
  margin-top: 15px;
}

.save-dialog {
  width: 525px;
  padding: 50px 60px 40px 60px;
  display: flex;
  align-items: center;
  flex-direction: column;
  position: absolute;
  z-index: 99999;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: #fff;
  border-radius: 20px;

  &__header {
    margin-bottom: 40px;
  }

  &__image {
    width: 214px;
    height: 115px;
    border-radius: 20px;
    object-fit: cover;
  }

  &__title {
    font-size: 40px;
    font-weight: 700;
    line-height: 98.1%;
    text-align: center;
    letter-spacing: -0.005em;
    color: #071d3b;
    margin-bottom: 20px;
  }

  &__description {
    font-size: 16px;
    line-height: 118.14%;
    text-align: center;
    letter-spacing: -0.005em;
    width: 330px;
    margin-bottom: 40px;
    color: rgba(7, 29, 59, 0.5);
  }

  &__form {
    margin-top: 16px;
    background-color: #f7f7f7;
    height: 56px;
    border-radius: 20px;
    display: grid;
    grid-template-columns: 1fr 95px;
    grid-template-areas:
      'label button'
      'input button';
    width: 380px;
  }

  &__label {
    font-size: 12px;
    letter-spacing: -0.005em;
    color: rgba(7, 29, 59, 0.37);
    grid-area: label;
    margin: 10px 20px 0;
    height: 13px;
  }

  &__input {
    border: none;
    font-size: 18px;
    letter-spacing: -0.005em;
    color: #071d3b;
    background: transparent;
    grid-area: input;
    height: 30px;
    line-height: 30px;
    margin-top: -5px;
  }

  &__button {
    width: 95px;
    height: 53px;
    background: var(--btn-primary-color, hsl(208, 100%, 41%));
    border-radius: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 18px;
    line-height: 118.14%;
    letter-spacing: -0.005em;
    color: #fff;
    grid-area: button;
    border: none;
    cursor: pointer;

    &:hover {
      opacity: 0.8;
    }
  }
}

.save-dialog__close {
  position: absolute;
  top: 13px;
  right: 10px;
  background: none;
  border: none;
  appearance: none;
  cursor: pointer;
}

.download-btn.loading .icon {
  animation: spin infinite linear 1s;
}
.icon {
  font-size: 14px;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(359deg);
  }
}
</style>
